import React from 'react';
import { Text } from '@chakra-ui/react';
import { getDurationMessage, getPriceText } from 'utils';
// eslint-disable-next-line import/no-duplicates
import { addSeconds, format, parse } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import { ru } from 'date-fns/locale';
import { GroupEventInfo, ServiceInfo } from '../types';

type Props = {
  event: GroupEventInfo;
  service?: ServiceInfo;
  showTime?: boolean;
};

export const InfoEventBrief: React.FC<Props> = ({
  event,
  service,
  showTime,
}) => {
  const {
    available,
    capacity,
    date,
    duration: eventDuration,
    time,
    visitName,
    visitStarted,
  } = event;
  const { duration = 0, showDuration } = service || {};

  return (
    <>
      <Text color="black" textStyle="body1">
        {visitName}
      </Text>
      <Text color="grayText">
        {showTime && (
          <Text as="span" mr={4}>
            {visitStarted
              ? format(
                  addSeconds(
                    parse(time, 'HH:mm', new Date(date)),
                    eventDuration,
                  ),
                  'до HH:mm',
                  {
                    locale: ru,
                  },
                )
              : time}
          </Text>
        )}
        {showDuration && (
          <Text as="span" mr={4} whiteSpace="nowrap">
            {getDurationMessage(duration)}
          </Text>
        )}
        {service?.showPrice && (
          <Text as="span" mr={4} color="highlight" whiteSpace="nowrap">
            {getPriceText(service)}
          </Text>
        )}
        <Text as="span" whiteSpace="nowrap">
          {available && available > 0
            ? `Свободно мест: ${available} из ${capacity}`
            : 'Места закончились'}
        </Text>
      </Text>
    </>
  );
};
